module.exports = __webpack_public_path__ + "img/716.9c9b65d8.jpg";